import { bool, object, string, oneOf } from 'prop-types'
import { kuiperClassNames } from '@opallabs/kuiper'
import ImageSlide from '../ImageSlide'
import SlideThumbnail from '../SlideThumbnail'

import './styles.scss'

const ImageSlideThumbnail = ({
  alignment = 'center',
  assetReference,
  backgroundImageURL,
  theme = {},
  withHoverableOverlay,
}) => (
  <SlideThumbnail
    className={kuiperClassNames('image-slide-thumbnail')}
    renderHeader={false}
    theme={theme}
  >
    <ImageSlide
      alignment={alignment}
      assetReference={assetReference}
      backgroundImageURL={backgroundImageURL}
      theme={theme}
      thumbnail={true}
      viewOnlyMode={true}
      withHoverableOverlay={withHoverableOverlay}
    />
  </SlideThumbnail>
)

ImageSlideThumbnail.propTypes = {
  alignment: oneOf(['center', 'fit', 'fill']),
  assetReference: object,
  backgroundImageURL: string,
  theme: object,
  withHoverableOverlay: bool,
}

export default ImageSlideThumbnail
